module.exports = __webpack_public_path__ + "img/news1.27e5e67d.jpg";